/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AmountApiDto } from './amount.model';

export interface AirportTransferApiDto {
  company?: AirportTransferApiDto.CompanyEnum;
  code?: string;
  name?: string;
  transferStation?: string;
  transferVehicle?: string;
  /** @deprecated */
  dropOffType?: AirportTransferApiDto.DropOffTypeEnum;
  transferServiceTypeDetail?: AirportTransferApiDto.TransferServiceTypeDetailEnum;
  transferServiceType?: AirportTransferApiDto.TransferServiceTypeEnum;
  stationType?: AirportTransferApiDto.StationTypeEnum;
  schoolCode?: string;
  schoolCountry?: string;
  configType?: string;
  uom?: string;
  minWeeks?: number;
  maxWeeks?: number;
  /** @deprecated */
  price?: AmountApiDto;
  multiCurrencyPrice?: Array<AmountApiDto>;
  destinationCurrency?: string;
  packageCode?: string;
  pricelist?: string;
  row?: number;
}
export namespace AirportTransferApiDto {
  export const CompanyEnum = {
    KIL: 'KIL',
    PL: 'PL',
    ALP: 'ALP',
    ESL: 'ESL',
  } as const;
  export type CompanyEnum = (typeof CompanyEnum)[keyof typeof CompanyEnum];
  export const DropOffTypeEnum = {
    COLLECTIVE: 'COLLECTIVE',
    PRIVATE: 'PRIVATE',
  } as const;
  export type DropOffTypeEnum = (typeof DropOffTypeEnum)[keyof typeof DropOffTypeEnum];
  export const TransferServiceTypeDetailEnum = {
    age_10_13: 'age 10-13',
    age_14_15: 'age 14-15',
    age_16_17: 'age 16-17',
    Collective: 'Collective',
    Private: 'Private',
  } as const;
  export type TransferServiceTypeDetailEnum = (typeof TransferServiceTypeDetailEnum)[keyof typeof TransferServiceTypeDetailEnum];
  export const TransferServiceTypeEnum = {
    ARRIVAL: 'ARRIVAL',
    DEPARTURE: 'DEPARTURE',
    ROUND_TRIP: 'ROUND_TRIP',
    NO_TRANSFER: 'NO_TRANSFER',
  } as const;
  export type TransferServiceTypeEnum = (typeof TransferServiceTypeEnum)[keyof typeof TransferServiceTypeEnum];
  export const StationTypeEnum = {
    AIRPORT: 'AIRPORT',
    TRAIN: 'TRAIN',
    BUS: 'BUS',
  } as const;
  export type StationTypeEnum = (typeof StationTypeEnum)[keyof typeof StationTypeEnum];
}
